module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.1561b42.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Medium.woff2
// module id = 453
// module chunks = 1